export default {
  title: 'Wachtwoord wijzigen',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'E-mailadres invoeren',
    },
    new_password: {
      label: 'Nieuw wachtwoord',
      placeholder: 'Wachtwoord invoeren',
      requirements: 'Uw wachtwoord moet 8 tekens, een hoofdletter en een cijfer bevatten',
    },
    confirm_password: {
      label: 'Nieuw wachtwoord bevestigen',
      placeholder: 'Wachtwoord bevestigen',
    },
    error_messages: {
      missing_info: 'Ontbrekende informatie',
    },
  },
  buttons: {
    change_password: 'Wachtwoord wijzigen',
  },
};
